import React from 'react'

import { mapContainer } from './MapComponent.module.css'

const MapComponent = ({ extraClassName }) => (
  <div className={`${mapContainer} ${extraClassName}`}>
    <iframe
      allowFullScreen={false}
      height="450"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9805.65305816389!2d4.2783!3d52.09041!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c5b8218383363b%3A0x495b2b70eb43ff66!2sEssential%20Aesthetics%20-%20Kliniek%20voor%20Plastische%20Chirurgie%2C%20Injectables%20%26%20Huidverbetering!5e0!3m2!1sen!2snl!4v1729497731811!5m2!1sen!2snl"
      title="map"
      width="600"
    />
  </div>
)

export default MapComponent
